import { render } from "./PesquisaOpiniao.vue?vue&type=template&id=dead8a5a&scoped=true"
import script from "./PesquisaOpiniao.vue?vue&type=script&lang=js"
export * from "./PesquisaOpiniao.vue?vue&type=script&lang=js"

import "./PesquisaOpiniao.vue?vue&type=style&index=0&id=dead8a5a&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dead8a5a"]])

export default __exports__